import { useState } from "react";
import { DropdownIcon } from "./Icon";
import { useNavigate, Link } from "@shopify/hydrogen/client";
import {
  TelephoneIcon,
  AboutIcon,
  NeedhelpIcon,
  InstagramIcon,
} from "../elements/Icon";

const Dropdown = (props) => {
  const [showOptions, setShowOptions] = useState(false);
  const handleClick = () => {
    setShowOptions(!showOptions);
  };

  return (
    <div className="px-8 text-left ">
      <div className="border-b border-[#B7BEC6] ">
        <div
          onClick={handleClick}
          // type="button"
          className="flex items-center justify-between w-full text-sm font-bold focus-within:bg-none h-14"
          id="menu-button"
        >
          {props.features && (
            <span className="uppercase ">{props.features} </span>
          )}
          {props.support && <span className="uppercase">{props.support} </span>}
          {props.company && <span className="uppercase">{props.company} </span>}
          {props.contact && <span className="uppercase">{props.contact}</span>}
          <button
            className={`${
              showOptions === true ? "rotate-180 focus:none " : "rotate-0"
            } transition-transform duration-100`}
          >
            <DropdownIcon />
          </button>
        </div>
      </div>
      <div
        className={` ring-black ring-opacity-5 w-full ease-in-out   py-2  ${
          showOptions == true ? "translate-y  sticky" : "translate-y hidden"
        } `}
        role="menu"
      >
        <div
          className=" text-[#B7BEC6] block px-4 py-2 text-sm w-full"
          role="menuitem"
          tabIndex="-1"
          id="menu-item-1"
        >
          {props.featuresOptions && (
            <div>
              <div className="flex flex-col gap-4 ">
                <Link
                  target="_blank"
                  to="https://www.liv-cycling.com/za/events/"
                  className="font-medium text-[14px]"
                >
                  Events
                </Link>
                <Link to="/store-locator" className="font-medium text-[14px]">
                  Find a Liv Retailer
                </Link>
                <Link to="/news" className="font-medium text-[14px]">
                  News
                </Link>
                <Link
                  to="https://www.liv-cycling.com/global/teams-and-riders"
                  target={"_blank"}
                  className="font-medium text-[14px]"
                >
                  Teams & Riders
                </Link>
                <Link to="/technology" className="font-medium text-[14px]">
                  Technology
                </Link>
              </div>
            </div>
          )}
          {props.supportOptions && (
            <div>
              <div className="flex flex-col gap-4 ">
                <Link to="/contact" className="font-medium text-[14px]">
                  Contact
                </Link>
                <Link
                  target="_blank"
                  to="https://www.liv-cycling.com/global/manuals"
                  className="font-medium text-[14px]"
                >
                  Owner's Manuals
                </Link>
                {/* <Link
                  to="https://www.liv-cycling.com/za/archive"
                  target={"_blank"}
                  className="font-medium text-[14px]"
                >
                  Bike Archive
                </Link> */}
                <Link to="/warranty" className="font-medium text-[14px]">
                  Warranty
                </Link>
                <Link to="/fitting-guide" className="font-medium text-[14px]">
                  Fitting Guide
                </Link>
              </div>
            </div>
          )}
          {props.companyOptions && (
            <div>
              <div className="flex flex-col gap-4 ">
                <Link to="/about" className="font-medium text-[14px]">
                  About Liv Bicycles
                </Link>
                <Link to="/cookie" className="font-medium text-[14px]">
                  Cookie Policy
                </Link>
                <Link
                  to="https://www.liv-cycling.com/za"
                  className="font-medium text-[14px]"
                  target="_blank"
                >
                  Global Website
                </Link>
              </div>
            </div>
          )}
          {props.contactOptions && (
            <>
              <div className="flex flex-col gap-4 text-sm">
                <Link
                  to="mailto: info@dragons.co.za"
                  className="font-medium text-[14px]"
                >
                  Email Us
                </Link>
                <Link to="mailto: info@dragons.co.za">info@dragons.co.za</Link>
                <Link to="tel:021 461 6252" className="font-medium text-[14px]">
                  021 461 6252
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default Dropdown;
